export default function getTopoObject(topo) {
  // pick first object inside topo.objects
  const keys = topo?.objects ? Object.keys(topo.objects) : [];
  if (!keys.length) return null;
  return topo.objects[keys[0]];
}